import { Client } from '../client';
import { getLiveService } from './live-service';

function _getLiveService() {
  const client = Client.sharedInstance();
  return getLiveService(client);
}

/**
 * Attaches a handler for connection status updates
 * @param {function} func
 */
function onConnectionStatusUpdates(func) {
  _getLiveService().onConnectionStatusUpdates(func);
}

/**
 * Removes a handler for connection status updates.
 * If no handler is specified, removes all handlers
 * @param {function} [func]
 */
function offConnectionStatusUpdates(func) {
  _getLiveService().offConnectionStatusUpdates(func);
}

/**
 * Checks whether live service is ready to subscribe or publish messages
 */
function isInitialized() {
  return _getLiveService().isInitialized();
}

/**
 * @private
 */
export const LiveServiceFacade = {
  onConnectionStatusUpdates,
  offConnectionStatusUpdates,
  isInitialized
};



// WEBPACK FOOTER //
// /home/travis/build/Kinvey/js-sdk/src/core/live/live-service-facade.js